import { Icon } from "@iconify/react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "./Modal.css";

const ModalEndChatLiveChat = ({ onClose, handleEndChat, isEndingChat }) => {
  return (
    <div className="overlay">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer end-chat"
      >
        <div className="modalRight">
          <CloseOutlinedIcon className="closeBtn" onClick={onClose} />

          <div className="content">
            <h1>Perhatian!</h1>
            <p>Apakah Anda yakin untuk menghentikan sesi live chat ini?</p>
          </div>

          <div className="btnContainer">
            <button className="btn_Cancel" onClick={onClose}>
              Batal
            </button>

            <button
              className="btn_Confirm"
              disabled={isEndingChat}
              onClick={() => {
                handleEndChat();
                onClose();
              }}
            >
              {isEndingChat && <Icon height="24" icon="eos-icons:loading" />}
              Ya
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalEndChatLiveChat;
